// extracted by mini-css-extract-plugin
export var equalColumn = "_dn-0";